import { Header } from "./header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./home";
import { Terms } from "./pages/legal/terms";
import { PrivacyPolicy } from "./pages/legal/policy";
import { Unsubscribe } from "./pages/subscription/unsubscribe";
import { Verification } from "./pages/subscription/verification";
import { Goodies } from "./goodies";
import { Project } from "./project_download/project";
import { Footer } from "./footer";
export const App = () => {
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
                <Route path="/goodies" element={<Goodies />} />
                <Route path="/goodies/:id" element={<Project />} />
                <Route path="/verification/:token" element={<Verification />} />
                <Route path="*" element={<Home />} />
            </Routes>
            <Footer />

            <div className="vignette-overlay"></div>
            <div className="grain-overlay"></div>
        </BrowserRouter>
    );
};
